import styled from 'styled-components';
import {
  desktop_container_maxwidth,
  tablet_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

const BaseStyles = styled.div`
  /* stylelint-disable */
  max-width: ${desktop_container_maxwidth}px;
  margin: 0 auto;
  padding-bottom: 100px;
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  ul {
    padding-inline-start: 40px;
  }
  ul li {
    font-family: 'source-sans-pro', sans-serif;
    font-size: 14px;
    color: ${Colors.primary.white.tint};
  }
  p,
  .emphasize {
    font-size: 14px;
  }
  .indent {
    padding-left: 40px;
  }
  .click {
    font-style: italic;
  }
  .copyright-infringement {
    font-size: 14px;
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    padding: 0px 15px 100px;
  }
`;

export const LegalStyles = styled(BaseStyles)`
  a {
    text-decoration: none;
  }

  p,
  ul {
    margin: 0px 0px 10px;
  }
  .underlined-header {
    margin: 10px 0;
    color: ${Colors.primary.black.standard};
    font-size: 15px;
    font-weight: 400;
    font-style: italic;
    text-decoration: underline;
  }
`;

export const LegalTermsAccountsStyles = styled(BaseStyles)`
  h5 {
    text-transform: uppercase;
  }
`;

/* Keeping these styles just in case necessary on these pages. */
export const PrivacyStyles = styled(BaseStyles)`
  p {
    margin-bottom: 0;
  }

  p.download {
    font-weight: 600;
    margin-bottom: 20px;
  }
  table,
  td,
  th {
    border: solid 1px #dbdbdb;
  }
  table {
    margin-top: 20px;

    td {
      padding: 10px 35px;
      text-align: center;

      &.reasons,
      &.reasons-heading {
        text-align: left;
      }
    }
  }
  ul.no-indent {
    padding-left: 15px;
  }
  p.mini-border {
    width: 45px;
    height: 2px;
    border-top: 1px solid #bebcc1;
    margin-top: 20px;
  }
  .privacyContainer {
    margin: 75px 53px auto;
    .privacyHeader {
      margin-bottom: 48px;
    }
    .privacyLinkItem {
      padding-bottom: 21px;
      > a {
        color: ${Colors.primary.black.standard};
        font-size: 18px;
        font-weight: 400;
        line-height: 29px;
      }
    }
  }

  @media only screen and (max-width: ${desktop_breakpoint}px) {
    table,
    td,
    th {
      display: block;
      border: none;
      float: left;
    }
    table {
      width: 100%;
      border-bottom: 1px solid #cecece;
      margin-bottom: 25px;

      td {
        text-align: left;
      }
    }
    .do-we-share-heading,
    .limit-sharing-heading {
      display: none;
    }
    .reasons {
      width: 100%;
      border-top: 1px solid #cecece;
    }
    .do-we-share {
      padding-left: 65px;

      p {
        &:before {
          content: 'Do Vanderbilt, HomeFirst, CMH, Properties, and Wimbledon share?';
          padding-right: 10px;
        }
      }
    }
    .limit-sharing {
      padding-left: 65px;

      p {
        &:before {
          content: 'Can you limit this sharing?';
          padding-right: 10px;
        }
      }
    }
  }
`;

export const DispatchTermsStyles = styled(LegalStyles)`
  .underline-header,
  .underline-text {
    text-decoration: underline;
  }
  ol {
    padding-inline-start: 40px;
  }
`;
